import React from "react";
import styled from "styled-components";
import { Controller } from "react-hook-form";
import { Row, Col, Checkbox, Button, Divider } from "antd";
import { StyledTitle } from "../../../../pages/jobs/add";
import { StyledCheckbox } from "./bindingCheckbox";
import { PlusOutlined } from "@ant-design/icons";
import { StyledContainer } from "./coverSection";
import _ from "lodash";

const FinishingCheckbox = (props) => {
  const {
    setValue,
    data,
    status,
    control,
    setFinishingModalVisible,
    errors,
    trigger,
  } = props;

  if (status === "loading") {
    return <h1>Loading...</h1>;
  }

  return (
    <Row>
      <Col xs={24}>
        <StyledContainer
          style={{ marginRight: "10px" }}
          error={_.get(errors, "finishings")}
        >
          <StyledMainDivider>Finishing</StyledMainDivider>
          <>
            {errors && _.get(errors, "finishings") && (
              <Row>
                <StyledErrorCheckbox>
                  <p>{errors && _.get(errors, `finishings.message`)}</p>
                </StyledErrorCheckbox>
              </Row>
            )}
          </>
          <Controller
            control={control}
            name="finishings"
            render={({ onChange, value }) => {
              return (
                <Checkbox.Group
                  onChange={(e) => {
                    setValue("finishings", e);
                    trigger("finishings");
                  }}
                  value={value}
                >
                  <Row>
                    {data?.map((finishing, index) => (
                      <Col xs={24} key={`finishing-${index}`}>
                        <StyledCheckbox value={finishing.id}>
                          {finishing.name}
                        </StyledCheckbox>
                      </Col>
                    ))}
                  </Row>
                </Checkbox.Group>
              );
            }}
          />
          <StyledMinimalButton
            onClick={() => setFinishingModalVisible(true)}
            icon={<PlusOutlined />}
            type="link"
          >
            Add finishing
          </StyledMinimalButton>
        </StyledContainer>
      </Col>
    </Row>
  );
};

export const StyledMinimalButton = styled(Button)`
  color: ${(props) => props.theme.colors.grey[600]};
  font-weight: 500;
  transition: all 0.3s;
  align-self: flex-start;
  padding: 0;
  margin-top: ${(props) => props.theme.spacing[2]};

  :hover {
    color: ${(props) => props.theme.colors.primary};
  }
  :active,
  :focus {
    color: ${(props) => props.theme.colors.grey[800]};
  }
`;

export const StyledErrorCheckbox = styled.span`
  color: ${(props) => props.theme.colors.red[600]};
  padding: 0;
  margin: 0;
`;

export const StyledMainDivider = styled(Divider)`
  ::before {
    border-top: 1px solid ${(props) => props.theme.colors.grey[200]} !important;
  }

  ::after {
    border-top: 1px solid ${(props) => props.theme.colors.grey[200]} !important;
  }
`;

export default FinishingCheckbox;
